import { useWindowSize } from "../../../hooks/useWindowSize";
import {
  // ArrowComponent,
  LeftCircleArrow,
  RightCircleArrow,
} from "../../shared/ArrowComponent";
import { OnCurtainStart, Screen } from "../../../types/types";
import { springConfigs } from "../../../constants/springConfigs";
import { useSpring } from "react-spring";
import { CircularButton } from "../../shared/CircularButton";
import { bioPink } from "../../../constants/constants";

export const LeftArrow = ({
  gridArea,
  onCurtainStart,
  screenLeft,
  screenRight,
  containerStyle,
}: {
  gridArea?: string;
  onCurtainStart: OnCurtainStart;
  screenLeft: Screen;
  screenRight: Screen;
  containerStyle?: React.CSSProperties;
}) => {
  const { vertical } = { ...useWindowSize() };
  return (
    <div
      style={{
        gridArea,
        flex: vertical ? "" : 1,
        display: "flex",
        width: "100%",
        zIndex: 9999,
        ...containerStyle,
      }}
    >
      <LeftCircleArrow {...{ onCurtainStart, screenLeft, screenRight }} />
    </div>
  );
};
export const RightArrow = ({
  gridArea,
  onCurtainStart,
  screenLeft,
  screenRight,
  containerStyle,
}: {
  gridArea?: string;
  onCurtainStart: OnCurtainStart;
  screenLeft: Screen;
  screenRight: Screen;
  containerStyle?: React.CSSProperties;
}) => {
  const { vertical } = { ...useWindowSize() };
  return (
    <div
      style={{
        gridArea,
        flex: vertical ? "" : 1,
        display: "flex",
        width: "100%",
        zIndex: 9999,
        ...containerStyle,
      }}
    >
      <RightCircleArrow {...{ onCurtainStart, screenLeft, screenRight }} />
    </div>
  );
};

export const Arrows = ({
  gridArea,
  onCurtainStart,
  screenLeft,
  screenRight,
}: {
  gridArea: string;
  onCurtainStart: OnCurtainStart;
  screenLeft: Screen;
  screenRight: Screen;
}) => {
  const { vertical, w } = { ...useWindowSize() };

  const { animatedOffset } = useSpring({
    from: { animatedOffset: 1 },
    to: { animatedOffset: 0 },
    config: springConfigs.outlineAppear,
  });

  return (
    <div
      id="Arrows"
      style={{
        gridArea,
        width: "80%",
        display: "grid",
        gridTemplate: `
        "a b"
        / 1fr 1.5fr
        `,
        placeItems: "center",
        gap: w(1),
        zIndex: 99999,
      }}
    >
      <CircularButton
        {...{
          animatedOffset,
          color: "white",
          left: true,
          onCurtainStart,
          screenLeft,
          screenRight,
          // containerStyle: {
          //   height: "50px",
          // },
        }}
      />
      <CircularButton
        {...{
          animatedOffset,
          color: bioPink,
          left: false,
          onCurtainStart,
          screenLeft,
          screenRight,
        }}
      />
    </div>
  );
};
